import {
  Content,
  Item,
  Root,
  Trigger,
  Viewport,
} from '@radix-ui/react-navigation-menu'
import { Button } from '@n26/nxd'
import { LocaleSwitcher } from '@components/LocaleSwitcher'
import { COUNTRIES_DETAILS, LANGUAGE_LABELS } from '@constants/countryDetails'
import { useGetCountryLanguage } from '@hooks/useGetCountryLanguage'
import { useLocaliseString } from '@hooks/useLocaliseString'

type LocaleSwitcherProps = {
  isFooter?: boolean
}

type LocaleSwitcherMenuDropdownProps = {
  isFooter?: boolean
  excludeCountrySwitcher?: boolean
  isOpeningToLeft?: boolean
}

export const LocaleSwitcherMenuButton = ({ isFooter }: LocaleSwitcherProps) => {
  const { country, language } = useGetCountryLanguage()
  const localiseString = useLocaliseString()

  const FlagIcon = COUNTRIES_DETAILS[country].FlagIcon
  const languageLabel = isFooter
    ? localiseString(LANGUAGE_LABELS[language])
    : language.toUpperCase()

  return (
    <Button
      leadingIcon={<FlagIcon className='w-16' testId={`${country}-flag`} />}
      variant={isFooter ? 'primary' : 'tertiary'}
      color={isFooter ? 'teal' : 'neutral'}
      size='small'
    >
      {languageLabel}
    </Button>
  )
}

export const LocaleSwitcherMenuDropdown = ({
  isFooter,
  excludeCountrySwitcher,
  isOpeningToLeft,
}: LocaleSwitcherMenuDropdownProps) => {
  return (
    <Root className='justify-end outline-none'>
      <Item className='list-none'>
        <Trigger asChild>
          <div>
            <LocaleSwitcherMenuButton isFooter={isFooter} />
          </div>
        </Trigger>
        <Content className='bg-neutral md:w-fit w-full rounded-lg p-16 shadow-4'>
          <LocaleSwitcher excludeCountrySwitcher={excludeCountrySwitcher} />
        </Content>
        <div
          className={`absolute z-10 right-0 sm:w-auto m-16 w-11/12 ${
            isFooter ? 'md:bottom-full bottom-1/3 ' : 'top-full'
          } ${!(isFooter || isOpeningToLeft) && 'sm:right-auto'}`}
        >
          <Viewport />
        </div>
      </Item>
    </Root>
  )
}
